import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('bringozPriceOffer', bringozPriceOffer);

function bringozPriceOffer($filter, splitService) {
  return function bringozPriceFilter(priceLine, defaultValue) {

    if (_.isUndefined(priceLine)) {
      return defaultValue || '--';
    }

    const currency = splitService.getCurrencyCode();
    const discount = _.get(priceLine, 'discount', 0);
    const price = _.get(priceLine, 'price', 0);
    const count = _.get(priceLine, 'count', 0);
    const calculatedPrice = (price + discount) * count;
    return $filter('isoCurrency')(calculatedPrice, currency);
  }
}
